import { CSSProperties } from "react";
export const DSpace = ({ style }: { style?: CSSProperties }) => {
    return <div style={{ flex: 1, display: "flex", ...style }} />;
};
